import $ from 'jquery';
import { Loader } from "@googlemaps/js-api-loader"
import "./frontend-dropdown.js";

(function() {

    const mapElement = document.querySelector(".member__map");

    const mapCenter = {
        lat: 46.9, 
        lng: 8.22
    };

    const mapInitialZoom = 7.95;


    let circle = false;
    let map = false;
    let markers = [];

    const loader = new Loader({
        apiKey: "AIzaSyBF0n2CMv4SDdX4oeBywKfTkD7vSfFxKh4",
        libraries: ["geometry"],
    });    

    let mapInitialized = false;
    const initMap = () => loader.load().then(async function() {
        mapInitialized = true;

        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        /**
         *  Init Map
         */ 
        map = new Map( mapElement, {
            zoom: mapInitialZoom,
            center: mapCenter,
            streetViewControl: false,
            mapTypeControl: false,
            mapId: "400b2f31329ea032",
        });

        /**
         * Marker hinzufügen
         */

        if( window.members.length ) {
            
            window.members = window.members.map( member => {  
                
                if( ! member.position ) {
                    return member;
                }

                member.marker = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    content: getMarkerHTML( member ),
                    position: member.position
                });

                // Klick auf Marker
                member.marker.addListener("click", () => {
                    toggleMemberListItemHighlight( member.id );
                    toggleMarkerDetails( member.id );
                });
    
                return member;
                
            });

        }

        /**
         * Event-Listener
         */


        // Klick auf Listenelement
        $(".member__list li").on( "click", function() {
            
            toggleMemberListItemHighlight( $(this).data("member-id") );
            toggleMarkerDetails( $(this).data("member-id") );

            // Map zentrieren
            let memberId = $(this).data("member-id");
            let isOpened = $(".map-marker[data-member-id='" + memberId + "']").hasClass("opened");

            if( isOpened ) {
                map.setCenter( members.find( member => member.id === memberId ).position );
            }

        })


        /**
         * Togglet Marker-Details
         * @param {Int|String} memberId 
         */

        const toggleMarkerDetails = ( memberId ) => {

            // Geklicktes Element suchen
            let $marker = $(".map-marker[data-member-id='" + memberId + "']");
            let wasOpened = $marker.hasClass("opened");

            // Alle zurücksetzen
            $(".map-marker").removeClass("opened");

            // Marker Details togglen
            $marker.toggleClass("opened", ! wasOpened);

        }


        /**
         * Toggled Highlight der Listenelemente der Mitglieder-Liste
         * @param {Int|String} memberId 
         */
        const toggleMemberListItemHighlight = ( memberId ) => {

            // Geklicktes Element suchen
            let $listItem = $( ".member__list [data-member-id='" + memberId + "']" );
            let wasHighlighted = $listItem.hasClass("highlight");

            // Alle zurücksetzen
            $(".member__list li").removeClass("highlight");

            // Element hervorheben
            $listItem.toggleClass("highlight", ! wasHighlighted );

            // Hinscrollen, wenn das Element hervorgehoben ist
            if( ! wasHighlighted ) {
                $(".member__list-container").animate( { "scrollTop": $listItem.offset().top - $(".member__list").offset().top }, 350);
            }

        }




        /**
         * --- Filter ---
         */

        /**
         * Produktgruppen-Filter: Beim Filter nach Produktgruppen werden Marker und Listenelemente 
         * von nicht zum Filter passenden Mitgliedern ausgeblendet
         */
        $(".product-group-dropdown").on('change', function() {

            let filterValue = JSON.parse( $(this).attr("data-value") );

            // Reset
            $(".map-marker, .member__list li").removeClass("filtered-group");

            // if( ! filterValue.length ) {
            //     return;
            // }

            members.map( member => {

                let isFiltered = member.productgroups.filter( groupId => filterValue.includes( groupId.toString() ) ).length === 0

                // Marker
                $(".map-marker[data-member-id='" + member.id + "']").toggleClass("filtered-group", isFiltered);       
                
                // Listenelement
                $(".member__list li[data-member-id='" + member.id + "']").toggleClass("filtered-group", isFiltered);

            })

            // Gefilterte Mitglieder nach unten schieben
            
            $(".member__list li").sort( function( listElement1, listElement2 ) {

                // Compare distances for sorting
                if ($(listElement1).hasClass("filtered-group") && ! $(listElement2).hasClass("filtered-group")) return 1;
                if ($(listElement2).hasClass("filtered-group") && ! $(listElement1).hasClass("filtered-group")) return -1;
                
                return 0;

            } ).appendTo(".member__list");


        });

        // Zu Beginn einmal auslösen
        $(".product-group-dropdown").trigger("change");



        // PLZ_Filter + Umkreis
        const geocode = ( address, callback ) => {
                
            var geocoder = new google.maps.Geocoder();
        
            geocoder.geocode( { 
                
                address: address + ", Schweiz" 
            
            }, function( results, status ) {

                    if( status == google.maps.GeocoderStatus.OK ) {
                        callback( results[0].geometry.location );
                    }

                    else {
                        callback( false );
                    }

            } );

        }

        const drawCircle = ( location, radius ) => {

            hideCircle();

            // Remove circle if exists
            if( $(mapElement).data("circle") ) {
                $(mapElement).data("circle").setMap(null);
            }

            circle = new google.maps.Circle( {
                strokeColor: '#992530',
                strokeOpacity: 0.3,
                strokeWeight: 1,
                fillColor: '#992530',
                fillOpacity: 0.1,
                map,
                center: location,
                radius: radius * 1000
            } );

            $(mapElement).data("circle", circle);

        }            

        $(".filter").on('submit', function( e ) {

            e.preventDefault();

            // Alle Werte holen
            var formData = new FormData( $(".filter").get(0) );

            let plz = formData.get("plz");
            let radius = formData.get("radius");

            if( plz && radius ) {
                geocode( plz + ", Schweiz", function( location ) {
                    drawCircle( location, radius );
                    filterMemberRadius( location, radius );
                });
            }

        });

    })
    
    // Init map, if consent is given through the consent manager.
    document
    .getElementById("gdpr-consent-manager").addEventListener("allowed", function (event) {
      if (event.detail === 'TOOLS.GOOGLE_MAPS' && !mapInitialized) {
        initMap();
      }
    });

    // Request re-sending of events from consent manager, in case they have already fired.
    document.getElementById( 'gdpr-consent-manager' ).dispatchEvent( 
        new Event( 'publishState' ) 
    );

    // Grant consent through the consent manager, dedicated button in placeholder is clicked.
    // This will in turn fire the allowed event, which will trigger the map initialization above.
    $('[data-grant-google-map-consent]').on('click', function() {
        allow("TOOLS.GOOGLE_MAPS");
    });


    /**
     * Liefert das HTML für den Marker
     * 
     * @param {object} member 
     * @returns {HTMLElement} markerContent
     */
    const getMarkerHTML = ( member ) => {

        let $marker = $($("#marker-template").html());

        $marker.attr("data-member-id", member.id);
        $(".member-logo", $marker).attr("src", member.logo ? member.logo : "" );
        $(".member-name", $marker).html(member.name);
        $(".member-address", $marker).html(member.address);
        $(".member-link", $marker).attr("href", member.website).html(member.website);

        return $marker.get(0);
    }


    const filterMemberRadius = ( location, radius ) => {

        window.members.map( member => {

            if( ! member.position ) {
                return;
            }

            let distance = getDistance( location, member.position);

            let $marker = $(".map-marker[data-member-id='" + member.id + "']");
            let $listElement = $(".member__list li[data-member-id='" + member.id + "']");

            $listElement.data("distance", distance);

            $(".distance", $listElement).html( distance.toFixed(1) + " km" ).removeClass("hidden");

            $marker.toggleClass("filtered-radius", distance > radius);
            $listElement.toggleClass("filtered-radius", distance > radius);

        })

        sortMembersByDistance();

    }


    const sortMembersByDistance = () => {

        $(".member__list li").sort( function( listElement1, listElement2 ) {

            var distance1 = $(listElement1).data("distance") || Infinity; // Use Infinity to handle undefined or null
            var distance2 = $(listElement2).data("distance") || Infinity;

            var filtered1 = $(listElement1).hasClass("filtered-group");
            var filtered2 = $(listElement2).hasClass("filtered-group");

            // Compare distances for sorting
            if (distance1 < distance2 || ( filtered2 && ! filtered1 ) ) return -1;
            if (distance1 > distance2 || ( filtered1 && ! filtered2 ) ) return 1;
            
            return 0;

        } ).appendTo(".member__list");

    }


    const getDistance = ( location1, location2 ) => {
        return google.maps.geometry.spherical.computeDistanceBetween( location1, location2 ) / 1000;
    }


    
 

    $(".remove-filters ").click(function(e) {

        e.preventDefault();
        reset();

    } );


    function reset() {

        // Umkreis entfernen
        hideCircle();

        // Kartenausschnitt zurücksetzen
        if( map ) {
            map.setCenter(mapCenter);
            map.setZoom(mapInitialZoom);
        }

        $(".map-marker").removeClass("opacity-30");

        // Liste zurücksetzen
        $(".list__member").addClass("list__member--visible");
        $(".list__member .member__details").slideUp();

        // Liste nach oben scrollen
        // $(".map__list").scrollTo(0, 150);

        // Formular-Input
        // $(".map__input").attr("value", "");
        $(".map__input").val("");

        $(".product-group-dropdown input").prop("checked", true).trigger("change");

    }


   
    function geocodeAdress( address, callback ) {

        var geocoder = new google.maps.Geocoder();

        geocoder.geocode( { 
            
            address: address + ", Schweiz" 
        
        }, function( results, status ) {

                if( status == google.maps.GeocoderStatus.OK ) {
                    callback( results[0].geometry.location );
                }

                else {
                    callback( false );
                }

        } );

    }


    function fitMapToLocations( locations ) {

        var bounds = new google.maps.LatLngBounds();
        
        locations.map( function( location ) {
            bounds.extend(location);
        } );

        if ( circle ) {
            bounds.union(circle.getBounds());
        }

        map.fitBounds(bounds);

    }


    function hideCircle() {

        if ( circle ) {
            circle.setMap(null);
        }

    }



    function filterList( filteredmembers ) {

        $(".list__member").removeClass("list__member--visible");

        filteredmembers.forEach( function(member) {

            $("#list-member-" + member.id ).addClass("list__member--visible");

        } );

    }

    function initFocus() {

        $(".list__member").click(function( ){
            focusmember( parseInt($(this).attr("id").replace("list-member-", "") ) );
        } );

    }

    function focusmember( memberId ) {

        if ( ! $("#list-member-" + memberId).hasClass("list__member--visible") ) {
            reset();
        }
        
        // Geöffnete member schließen
        $(".member__details:visible").slideUp();

        // Gewählten member öffnen
        $(".member__details", $("#list-member-" + memberId)).slideDown( function() {

            // member in memberliste erweitern
            $(".map__list").scrollTo(
                $("#list-member-" + memberId),
                250
            );

        });


        markers.map( function( marker ) {

            // Opacity von nicht gewählten Markern senken
            marker.setOpacity(0.5);

            // Gewählter Marker: 100% Opacity, Karte auf Marker zentrieren
            if ( marker.member.id === memberId ) {
                marker.setOpacity(1);
                map.setCenter(marker.position);
                map.setZoom(12);
            }

        } );

    }

})();